import { Schema } from "rsuite";

const { StringType, ArrayType, DateType, NumberType } = Schema.Types;

export const PatientFormSchema = Schema.Model({
  CaseWorker: StringType()
    .maxLength(60)
    .isRequired("Case Worker Name is required"),
  CaseWorkerEmail: StringType()
    .maxLength(50)
    .isEmail("Must be a valid email")
    .isRequired("Case Worker Email is required"),
  DateOfBirth: DateType(),
  FirstName: StringType().maxLength(30).isRequired("First Name is required"),
  LastName: StringType().maxLength(30).isRequired("Last Name is required"),
  FormAttachFile: ArrayType("Please select valid files"),
  Gender: StringType().isRequired("Gender is required"),
  HHAExchangeId: StringType().maxLength(50),
  InsuranceId: StringType()
    .maxLength(50)
    .isRequired("Insurance Id is required"),
  InsuranceTypeId: StringType().isRequired("Insurance Type is required"),
  MedicalCode: StringType()
    .maxLength(50)
    .isRequired("Medical Code is required"),
  PhoneNumber: StringType()
    .maxLength(20)
    .isRequired("Phone Number is required"),
  ProfilePic: ArrayType("Please select valid files"),
  PerUnitCost: NumberType().max(10000).isRequired("Rate is required"),
  ServiceAuthorizationFile: ArrayType("Please select valid files"),
  ServiceAuthorizationStartDate: DateType(),
  ServiceAuthorizationEndDate: DateType(),
  SpecialInstructions: StringType().maxLength(500),
  TotalUnit: NumberType()
    .max(10000)
    .isRequired("TotalUnit is required"),
  Address: StringType().maxLength(200),
  Apartment: StringType().maxLength(50),
  Languages: ArrayType().isRequired("Languages is required"),
  EmergencyContactPersonName: StringType()
    .maxLength(60)
    .isRequired("Emergency Contact Person Name is required"),
  EmergencyContactPersonPhone: StringType()
    .maxLength(20)
    .isRequired("Emergency Contact Person Phone is required"),
});
